module.exports = "/Public/build/5c113e317f065dc27c85e7c44b5a5c02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DepartmentMarker/selskap-gul-42x49px.svg
// module id = 837
// module chunks = 0